"use strict";function chooseMobileContacts$(o){return ddSdk_1.ddSdk.invokeAPI(apiName,o)}var _a;Object.defineProperty(exports,"__esModule",{value:!0}),exports.chooseMobileContacts$=void 0;var ddSdk_1=require("../../../lib/ddSdk"),apiName="biz.contact.chooseMobileContacts";ddSdk_1.ddSdk.setAPI(apiName,(_a={},_a[ddSdk_1.ENV_ENUM.ios]={vs:"3.1"},_a[ddSdk_1.ENV_ENUM.android]={vs:"3.1"},_a)),exports.chooseMobileContacts$=chooseMobileContacts$,exports.default=chooseMobileContacts$;


//////////////////
// WEBPACK FOOTER
// ./~/_dingtalk-jsapi@2.13.71@dingtalk-jsapi/api/biz/contact/chooseMobileContacts.js
// module id = 930
// module chunks = 106